import store from 'shared/store'
import buildClientAPI from 'views/providers/clientAPI'
import {
  notepadHeartToggle,
  handleNotepadError
} from 'views/utils/notepadUtils'
import { WISHLIST_SELECTORS } from 'views/assets/scripts/consts'

const attachEventListener = async () => {
  const {
    pageProperties: { productId, isPim }
  } = store.getPublicRuntimeConfig()
  const { clientFockService } = buildClientAPI()
  if (!isPim) {
    return
  }

  let isInNotepad = false

  let status
  try {
    const productRes = await clientFockService.fetchProductFromNotepad(
      productId
    )
    status = productRes.status
  } catch (err) {
    status = err.response.status
  }
  switch (status) {
    case 200:
      isInNotepad = true
      break
    case 404:
      isInNotepad = false
      break
    default:
      return
  }

  const wishlistWrapper = document.querySelector(WISHLIST_SELECTORS.WRAPPER)
  if (!wishlistWrapper) {
    return
  }
  const wishListLink = wishlistWrapper.querySelector(WISHLIST_SELECTORS.BUTTON)
  /** @type HTMLElement */
  const tooltipTextContainer = document.querySelector(
    WISHLIST_SELECTORS.ADD_TO_WISHLIST_TOOLTIP
  )
  /** @type HTMLElement */
  const heartIcon = document.querySelector(WISHLIST_SELECTORS.HEART_ICON)
  /** @type HTMLElement */
  const heartFilledIcon = document.querySelector(
    WISHLIST_SELECTORS.HEART_FILLED_ICON
  )

  notepadHeartToggle(isInNotepad, { heartFilledIcon, heartIcon })

  wishListLink.addEventListener('click', async () => {
    if (!isInNotepad) {
      try {
        await clientFockService.addProductToNotepad(productId)
      } catch (err) {
        handleNotepadError(tooltipTextContainer)
      }
    } else {
      try {
        await clientFockService.removeProductFromNotepad(productId)
      } catch (err) {
        handleNotepadError(tooltipTextContainer)
      }
    }
    isInNotepad = !isInNotepad
    notepadHeartToggle(isInNotepad, { heartFilledIcon, heartIcon })
  })
}

export default attachEventListener
